webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(5);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  template: '<App/>',
	  components: { App: _App2.default }
	}).$mount('#app');

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Parallax = __webpack_require__(6);
	
	var _Parallax2 = _interopRequireDefault(_Parallax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Parallax: _Parallax2.default
	  }
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    parallax: {
	      default: true,
	      type: Boolean
	    },
	    speedFactor: {
	      default: 0.15,
	      type: Number
	    },
	    fixed: {
	      default: false,
	      type: Boolean
	    },
	    breakpoint: {
	      default: '(min-width: 968px)',
	      type: String
	    },
	    sectionHeight: {
	      default: 70,
	      type: Number,
	      required: false
	    }
	  },
	
	  data: function data() {
	    return {
	      el: null,
	      mediaQuery: null
	    };
	  },
	  mounted: function mounted() {
	    if (this.parallax && !this.fixed) {
	      this.el = this.$refs.parallax;
	      window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function (f) {
	        setTimeout(f, 1000 / 60);
	      };
	      this.init();
	    }
	  },
	
	
	  methods: {
	    animateElement: function animateElement() {
	      var parentHeight = this.$refs.block.offsetHeight;
	      var parallaxHeight = this.$refs.parallax.offsetHeight;
	      var availableOffset = parallaxHeight - parentHeight;
	      var animationValue = window.pageYOffset * this.speedFactor;
	
	      if (animationValue <= availableOffset && animationValue >= 0) {
	        this.el.style.transform = 'translate3d(0, ' + animationValue * -1 + 'px ,0)';
	      }
	    },
	    scrollHandler: function scrollHandler() {
	      var _this = this;
	
	      window.requestAnimationFrame(function () {
	        if (_this.isInView(_this.$refs.parallax)) {
	          _this.animateElement();
	        }
	      });
	    },
	    isInView: function isInView(el) {
	      var rect = el.getBoundingClientRect();
	
	      return rect.bottom >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight);
	    },
	    setupListener: function setupListener() {
	      if (this.mediaQuery.matches) {
	        window.addEventListener('scroll', this.scrollHandler, false);
	      } else {
	        window.removeEventListener('scroll', this.scrollHandler, false);
	      }
	    },
	    init: function init() {
	      this.mediaQuery = window.matchMedia(this.breakpoint);
	
	      if (this.mediaQuery) {
	        this.mediaQuery.addListener(this.setupListener);
	        this.setupListener();
	      }
	    }
	  }
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 4 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(4)
	
	/* script */
	__vue_exports__ = __webpack_require__(1)
	
	/* template */
	var __vue_template__ = __webpack_require__(8)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(3)
	
	/* script */
	__vue_exports__ = __webpack_require__(2)
	
	/* template */
	var __vue_template__ = __webpack_require__(7)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('section', {
	    ref: "block",
	    staticClass: "Masthead",
	    style: ({
	      height: _vm.sectionHeight + 'vh'
	    })
	  }, [_c('div', {
	    ref: "parallax",
	    staticClass: "Masthead__image",
	    class: {
	      'is-parallax': _vm.parallax, 'is-fixed': _vm.fixed
	    }
	  }, [_vm._t("default")], true)])
	},staticRenderFns: []}

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "position": "relative",
	      "z-index": "9999",
	      "background-color": "#fff"
	    }
	  }, [_c('h1', {
	    staticStyle: {
	      "margin": "0"
	    }
	  }, [_vm._v("Parallax Effect")]), _vm._v(" "), _c('parallax', [_c('img', {
	    attrs: {
	      "src": "static/img/pexels-photo-241307.jpeg"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "background-color": "#fff",
	      "height": "100vh"
	    }
	  }), _vm._v(" "), _c('h1', [_vm._v("Parallax fixed position ")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "position": "relative"
	    }
	  }, [_c('parallax', {
	    attrs: {
	      "fixed": true
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "static/img/pexels-photo-196416.jpeg"
	    }
	  })]), _vm._v(" "), _vm._m(1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticStyle: {
	      "background-color": "#fff",
	      "height": "100vh"
	    }
	  }, [_c('h1', {
	    staticStyle: {
	      "margin-top": "0",
	      "padding-top": "20px"
	    }
	  }, [_vm._v("Scroll down ⬇")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('div', {
	    staticStyle: {
	      "background-color": "#fff",
	      "height": "100vh"
	    }
	  })])
	}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.4eed5bdb25ebe223978a.js